{
  "el": {
    "inspiration_list": {
      "actions": {
        "cancel": "Αναίρεση",
        "delete": "Διαγραφή",
        "deleteMultiple": "Διαγραφή...",
        "delete_cancel": "Ακύρωση",
        "edit": "Επεξεργασία",
        "new": "Νέο άλμπουμ φωτογραφιών",
        "save": "Αποθήκευση",
        "submit": "Υποβολή",
        "tickBoxesDeletion": "Τσέκαρε τα πλαίσια των αρχείων που θέλεις να διαγραφούν."
      },
      "attributes": {
        "name": "Όνομα"
      },
      "info": "Τι σου αρέσει για το νέο σου σπίτι; Ανέβασε φωτογραφίες που σε εμπνέουν. Με τα άλμπουμ μπορείς να τις οργανώσεις σε θέματα: κουζίνα, μπάνιο, έπιπλα, ...",
      "labels": {
        "inspiration_list": "Λίστες εμπνεύσεων",
        "inspirationlist": "Άλμπουμ εμπνεύσεων",
        "inspirations": "Εμπνεύσεις",
        "noInspirationLists": "Δεν υπάρχουν ακόμη λίστες εμπνεύσεων",
        "noInspirations": "Δεν υπάρχουν ακόμη εμπνεύσεις"
      },
      "placeholders": {
        "customers": {
          "new": {
            "subtitle": "Δημιούργησε διαφορετικά άλμπουμ για την κουζίνα, το μπάνιο ή τα έπιπλά σου και ανέβασε φωτογραφίες που σε εμπνέουν.",
            "title": "Πώς θα διακοσμήσεις το νέο σου σπίτι;"
          }
        }
      },
      "validation": {
        "needTitle": "Ο τίτλος είναι υποχρεωτικός",
        "selectInspirationList": "Επίλεξε τουλάχιστον 1 λίστα εμπνεύσεων"
      }
    }
  }
}
